import { defineRealtimeEvent } from 'services';
import type { CreateResponse, DeleteResponse } from './commentStore';

/** Realtime and HTTP describe the same comment facts and share their envelopes. */
export const commentsCreated = defineRealtimeEvent<CreateResponse>('COMMENTS/CREATED');
export const commentsDeleted = defineRealtimeEvent<DeleteResponse>('COMMENTS/DELETED');
